@use 'themes/westfield' as *;
@use 'tools/color' as *;
@use 'tools/if-theme' as *;

.default {
  fill: #1c1f24;

  @include if-theme('scentregroup') {
    fill: color('Brand');
  }
}

.alt {
  fill: color('White');

  @include if-theme('scentregroup') {
    fill: #1c1f24;
  }
}

.direct-digital,
.direct-marketing {
  color: color('Blue Charcoal');

  :global {
    .chevron {
      color: color('Vibrant Teal');
    }
  }
}
